var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusSignIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 13.5a1.501 1.501 0 003 0V9h4.5a1.501 1.501 0 000-3H9V1.5a1.501 1.501 0 00-3 0V6H1.5a1.501 1.501 0 000 3H6v4.5z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02IDEzLjVDNiAxNC4zMjc2IDYuNjcyMzYgMTUgNy41IDE1QzguMzI3NjQgMTUgOSAxNC4zMjc2IDkgMTMuNVY5SDEzLjVDMTQuMzI3NiA5IDE1IDguMzI3NjQgMTUgNy41QzE1IDYuNjcyMzYgMTQuMzI3NiA2IDEzLjUgNkg5VjEuNUM5IDAuNjcyMzYzIDguMzI3NjQgMCA3LjUgMEM2LjY3MjM2IDAgNiAwLjY3MjM2MyA2IDEuNVY2SDEuNUMwLjY3MjM2MyA2IDAgNi42NzIzNiAwIDcuNUMwIDguMzI3NjQgMC42NzIzNjMgOSAxLjUgOUg2VjEzLjVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgPlusSignIcon as ReactComponent };